import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import { SetStateAction } from 'react';

import { dayjs } from '../Dayjs/dayjs-utils';

interface TimeInputProps {
    durationValue: string;
    label: string | undefined;
    onChange: ((e: string | null) => void) | ((e: SetStateAction<string>) => void);
    timezone?: string;
}

export default function TimeInput({
    durationValue,
    label,
    onChange,
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone,
}: Readonly<TimeInputProps>) {
    const currentDate = dayjs.utc().startOf('day');
    const duration = dayjs.duration(durationValue);

    const dateValue = currentDate.add(duration).local();

    return (
        <MobileTimePicker
            ampm={false}
            label={label}
            onChange={(dateObject) => {
                let newDuration = dayjs.duration(dayjs.utc(dateObject).diff(currentDate));

                // Change negative duration to positive. Example: -PT1H => PT22H (UTC +3)
                if (newDuration.asMilliseconds() < 0) {
                    newDuration = dayjs.duration(24, 'hours').add(newDuration);
                }

                // Duration is within the current day
                const adjustedDuration = dayjs.duration({
                    hours: newDuration.hours(),
                    minutes: newDuration.minutes(),
                    seconds: newDuration.seconds(),
                });

                const durationString = adjustedDuration.toJSON();
                onChange(durationString);
            }}
            sx={{ width: '100%' }}
            timezone={timezone}
            value={dateValue as unknown as string}
        />
    );
}
